/* eslint-disable sort-keys */
export const gameInfoUpdate = (key, updatedData) => ({
  payload: { key, updatedData },
  type: "UPDATE_TIME_INFO"
})

export const gameStartInfoUpdate = (time) => ({
  payload: time,
  type: "UPDATE_START_TIME"
})

export const gameQuestionUpdate = (question) => {

  // sort alphabetically 
  question.answers.sort((a, b) => a.answer > b.answer ? 1 : -1)

  return {
    payload: question,
    type: "UPDATE_QUESTION_INFO"
  }
}

export const gameAnswerUpdate = (answer) => {

  // sort alphabetically 
  answer.sort((a, b) => a.answer > b.answer ? 1 : -1)

  return {
    payload: answer,
    type: "UPDATE_ANSWER_INFO"
  }
}

export const gameScoresUpdate = (scores) => ({
  payload: scores,
  type: "UPDATE_SCORES_INFO"
})

export const gameTotalPlayersUpdate = (totalPlayers) => ({
  payload: totalPlayers,
  type: "UPDATE_TOTAL_PLAYERS_INFO"
})

export const gameSkinUpdate = (skin) => ({
  payload: skin,
  type: "UPDATE_SKIN"
})

export const gameRulesUpdate = (title, tagline, gameMode) => ({
  payload: {title, tagline, gameMode},
  type: "UPDATE_RULES_INFO"
})
export const gameUpdateIsFinalScore = (isFinalScore) => ({
  payload: isFinalScore,
  type: "UPDATE_IS_FINAL_SCORE"
})
export const gameUpdateIsRevealed = (isRevealed) => ({
  payload: isRevealed,
  type: "UPDATE_IS_REVEALED"
})
export const gameStartCountdown = () => ({
  payload: null,
  type: "START_COUNTDOWN",
})
export const gameResetCountdown = () => ({
  payload: null,
  type: "RESET_COUNTDOWN",
})